import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import { ApiResponse } from 'schemas/ApiResponse.schema';
import { apiFetch } from 'utils/apiUtils';

interface SubmitSummaryReportVariables {
  teamId: string;
  campaignId: string;
  iterationId: string;
  batchId: string;
}

export default function useSendReportToNotify() {
  const { tokens } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['summary_report', 'campaign'],
    mutationFn: async ({
      teamId,
      campaignId,
      iterationId,
      batchId,
    }: SubmitSummaryReportVariables) => apiFetch<ApiResponse>({
      path: `team/${teamId}/campaign/${campaignId}/iteration/${iterationId}/summary_report/${batchId}/submit`,
      method: 'PUT',
      accessToken: String(tokens.accessToken),
    }),
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['campaign'] });
      queryClient.refetchQueries({ queryKey: ['summary_report'] });
    },
  });
}
